/*jshint esversion: 6 */

import get from "lodash/get";

export const numberOfQuestions = data => {
    return data.questions.length;
}